'use strict';

/**
 * This directive exists as an alternative to ng-mouseenter,
 * as a bug exists in the header whereby the use of ng-mouseenter
 * is changing the url.
 */

module.exports = function(
) {
    return {
        link: function(scope, element, attrs) {
            element.on('mouseenter', function(event) {
                scope.$eval(attrs.mouseenter);
                return false;
            });
        }
    };
};
